export default "__VITE_ASSET__b9b1dee8__"